import { Colors } from 'APP/Themes'

export default {
  shimmerColors: [Colors.shimmerBase, Colors.shimmerHighlight, Colors.shimmerBase],
}
